module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAKBAMAAAByAqLJAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAVUExURYSNnYONnUdwTIOLnYWNnYONnYWNnxhK1fEAAAAGdFJOU6CBAJFg0OTD5OkAAAA7SURBVAjXYwhLA4JUBkdBIBBhUAIDIKVsBKbYEkCUQgIbE5BiY1JIUGIAYiU2IwY3JiUlhRQGA5B6ZgB/GgnjzF47jAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/icon-back-top.png
// module id = nuso
// module chunks = 34